import posthog from 'posthog-js';
import { track } from '@vercel/analytics';
import { getEnvironmentData } from '../utils/environment';
import { analyticsOptOut } from '../utils/privacy';

export const trackViewRequestDetails = (requestId, source = 'list') => {
  if (analyticsOptOut.hasOptedOut()) return;
  
  const eventData = {
    request_id: requestId,
    source: source,
    ...getEnvironmentData()
  };

  posthog.capture('view_request_details', eventData);
  track('view_request_details', eventData);
  
  // Add TikTok tracking
  if (typeof window !== 'undefined' && window.ttq) {
    window.ttq.track('ViewContent', {
      content_name: 'request_details',
      content_type: 'product',
      content_id: requestId
    });
  }
}; 